module.exports = __webpack_public_path__ + "img/QB HOUSE.c1d29f16.svg";